import React, { useEffect, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import Vector1 from "../assets/signup/Vector1.png";
import { Form, Input, message } from 'antd';
import user from "../assets/user.png";
import mail from "../assets/mail.png";
import { AppleFilled, EyeInvisibleOutlined, EyeTwoTone, GoogleOutlined, MessageOutlined } from '@ant-design/icons';
import Navbar from '../components/Navbar';
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";
import { useTranslation } from 'react-i18next';
import { registerUser } from '../redux/authSlice';
import { useDispatch, useSelector } from 'react-redux';

const SignUp = () => {

  const { t, i18n } = useTranslation();
  const { language } = i18n;

  const location = useLocation();
  const { phone, code } = location.state || {};

  // const phone = statePhone || localStorage.getItem("signup_phone");

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [locationUser, setLocationUser] = useState({ latitude: null, longitude: null });
  const [errorLocation, setErrorLocation] = useState(null);

  const [name, setName] = useState("");
  const [lastname, setLastName] = useState("");
  const [email, setEmail] = useState("");

  // useEffect(() => {
  //   if (navigator.geolocation) {
  //     navigator.geolocation.getCurrentPosition(
  //       (position) => {
  //         setLocationUser({
  //           latitude: position.coords.latitude,
  //           longitude: position.coords.longitude,
  //         });
  //         setErrorLocation(null);
  //       },
  //       (err) => {
  //         setErrorLocation(err.message);
  //       }
  //     );
  //   } else {
  //     setErrorLocation("Geolocation is not supported by your browser.");
  //   }
  // }, [errorLocation, dispatch]);

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setLocationUser({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          });
        },
        (err) => {
          setErrorLocation(err.message);
        }
      );
    } else {
      setErrorLocation("Geolocation is not supported by your browser.");
    }
  }, []);


  const { isLoading, error } = useSelector((state) => state.auth);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const userData = {
      name: name,
      last_name: lastname,
      email: email,
      phone: phone,
      code: code,
      longitude: locationUser.longitude || "0.0",
      latitude: locationUser.latitude || "0.0"
    };
    try {
      await dispatch(registerUser(userData)).unwrap();
      message.success(t("signed up"));
      navigate('/');
    } catch (error) {
      message.error(t("Failed to sign up"));
    }
  };

  return (
    <>
      <Navbar />
      {/* <div className='px-20 max-lg:px-5 grid grid-cols-2 max-lg:grid-cols-1 gap-10 lg:items-center relative pb-7'> */}
      <div className='px-20 max-lg:px-5 relative pb-7 lg:w-2/3 mx-auto'>

        <div className='bg-[#FCFBFA] rounded-3xl py-1'>
          <h3 className="text-[#14294F] text-2xl font-bold mt-5 leading-relaxed mx-auto text-center">
            {t("Enter your data to sign")}
          </h3>

          <form className="my-5 mx-7 max-lg:mx-3" onSubmit={handleSubmit}>
            <div className="bg-white border-2 border-[#EAA182] rounded-3xl p-7">
              <div className="grid grid-cols-2 max-lg:grid-cols-1 gap-2">
                <div>
                  <p className="text-[#283D63] text-center">
                    {t("First Name")} <span className="text-[#CC0F0F]">*</span>
                  </p>
                  <Form.Item
                    name="name"
                    rules={[{ required: true, message: t('Please enter your first name') }]}
                  >
                    <Input
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      placeholder={t("Eg. Johnny")}
                      suffix={<img src={user} className="w-[15px]" />}
                      className="h-[50px] mt-2 border-0 bg-[#F9FBFC]"
                    />
                  </Form.Item>
                </div>
                <div>
                  <p className="text-[#283D63] text-center">
                    {t("Last Name")} <span className="text-[#CC0F0F]">*</span>
                  </p>
                  <Form.Item
                    name="lastname"
                    rules={[{ required: true, message: t('Please enter your last name') }]}
                  >
                    <Input
                      value={lastname}
                      onChange={(e) => setLastName(e.target.value)}
                      placeholder={t("Eg. Doe")}
                      suffix={<img src={user} className="w-[15px]" />}
                      className="h-[50px] mt-2 border-0 bg-[#F9FBFC]"
                    />
                  </Form.Item>
                </div>
              </div>

              <div className='mt-5'>
                <p className="text-[#283D63] text-center">
                  {t("Email")} <span className="text-[#CC0F0F]">*</span>
                </p>
                <Form.Item
                  name="email"
                  rules={[{ required: true, message: t('Please enter your email') }]}
                >
                  <Input
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder={t("Eg. Solimannhene16@gmail.com")}
                    suffix={<img src={mail} className="w-[20px]" />}
                    className="h-[50px] mt-2 border-0 bg-[#F9FBFC]"
                  />
                </Form.Item>
              </div>

              <button
                type="submit"
                className="bg-[#FE9B71] text-white rounded-full px-14 py-3 mt-8 flex mx-auto font-semibold"
                disabled={isLoading}
              >
                {isLoading ? t("Loading...") : t("Submit")}
              </button>

              {error && (
                <p className="text-red-500 text-center mt-4">{error}</p>
              )}
            </div>
          </form>

          {/* <h3 className='text-2xl text-[#EAA182] text-center'>OR</h3>
          <div className='flex justify-around	mt-2 mb-7'>
            <div className='border-2 border-[#EAA182] rounded-2xl w-[90px] h-[90px] flex justify-center items-center'>
              <AppleFilled className='text-5xl text-[#EAA182] ' />
            </div>
            <div className='border-2 border-[#EAA182] rounded-2xl w-[90px] h-[90px] flex justify-center items-center'>
              <GoogleOutlined className='text-5xl text-[#EAA182]' />
            </div>
          </div> */}
        </div>
        <div>
          {/* <h1 className="text-[#14294F] text-4xl max-lg:text-2xl max-lg:mt-10 font-bold  leading-relaxed mx-auto text-center">
            {t("CREATE AN ACCOUNT &")} <br /> {t("UNLOCK CONVENIENCE")}
          </h1>
          <img src={Vector1} className={`w-[400px] h-[270px] absolute ${language == "en" ? "left-80 top-3" : "left-96 bottom-0"} z-10 max-lg:hidden`} />
          <p className={`text-[#737E91] text-lg ${language === "en" ? "mt-32" : "mt-20"} max-lg:mt-10 mx-auto text-center`}>
            {t("When agreeing to creating an account, You agree to our Terms & Conditions and Privacy Policy")}
          </p> */}
          <p className="text-[#14294F] text-lg mt-5 w-1/2 mx-auto text-center">{t("Already on Samoolah?")}
            <Link to="/signin" className="text-[#FE9B71]">{t("SIGN IN")}</Link></p>
        </div>
      </div>
    </>
  )
}

export default SignUp